import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createFragmentContainer, graphql } from 'react-relay';
import { Link } from 'dibs-elements/exports/Link';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { Header } from 'dibs-elements/exports/Header';

// components
import { viewMore } from '../../pdpMessages';
import { PageLayout } from 'dibs-elements/exports/PageLayout';

// styles
import styles from './PdpRespSimilarItemsContainer.scss';

function PdpRespSimilarItemsContainerComponent(props) {
    const {
        header,
        subtitle,
        subHeader,
        children,
        dataTn,
        gridWrapperClass,
        gridHeaderClass,
        isHorizontal,
        item,
        scrollToRef,
        ...options
    } = props;
    const wrapperClass = classnames(styles.wrapper, {
        [styles.hasSubtitle]: !!subtitle,
        [styles.isTopContainer]: options.isTopContainer,
    });
    const contentClass = classnames(styles.content, gridWrapperClass, {
        [styles.isHorizontal]: isHorizontal,
    });
    const subtitleClass = classnames(item?.isSold ? styles.subtitleSoldPdp : styles.subtitle, {
        [styles.hasHeader]: !!header,
    });
    const headerClass = classnames(styles.header, { [`${gridHeaderClass}`]: !!gridHeaderClass });

    const pageLayoutProps = {
        setViewportBackground: options.isDark, // to set the default dark viewport background
        // to remove the offets so that the the default layout would be coming from main PDP container
        setOffset: options.isDark,
    };

    return (
        <PageLayout {...pageLayoutProps} dataTn={dataTn}>
            <HeadingLevel>
                {Heading => (
                    <div tabIndex={-1} ref={scrollToRef} className={wrapperClass}>
                        {/* give wrapper tabIndex to allow focus on "view more" scroll to */}
                        {/* Header */}
                        {!!header &&
                            (item?.isSold ? (
                                <Fragment>
                                    <div className={headerClass}>
                                        <Header
                                            htmlElementType={Heading}
                                            title={header}
                                            dataTn="sold-header"
                                        />
                                    </div>
                                    <div className={styles.soldHeader} />
                                </Fragment>
                            ) : (
                                <Heading className={headerClass}>{header}</Heading>
                            ))}
                        {/* FULL WIDTH OF PAGE */}
                        <div className={contentClass} data-tn="pdp-similar-items">
                            {!!subHeader && subHeader}
                            {!!subtitle && (
                                <div className={subtitleClass}>
                                    {subtitle}{' '}
                                    <Link
                                        className={classnames(styles.viewMore, {
                                            [styles.viewMoreSoldPdp]: item?.isSold,
                                        })}
                                        onClick={options.onClickViewMore}
                                        dataTn="view-more-similar-items"
                                    >
                                        {viewMore}
                                    </Link>
                                </div>
                            )}
                            {/* Grid of Items */}
                            {children}
                        </div>
                    </div>
                )}
            </HeadingLevel>
        </PageLayout>
    );
}

PdpRespSimilarItemsContainerComponent.propTypes = {
    header: PropTypes.node,
    subHeader: PropTypes.node,
    subtitle: PropTypes.node,
    children: PropTypes.node,
    gridWrapperClass: PropTypes.string,
    gridHeaderClass: PropTypes.string,
    dataTn: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired,
    scrollToRef: PropTypes.object,

    // options
    isDark: PropTypes.bool,
    isHorizontal: PropTypes.bool,
    hideBar: PropTypes.bool,
    onClickViewMore: PropTypes.func,
    isTopContainer: PropTypes.bool,
};

export const PdpRespSimilarItemsContainer = createFragmentContainer(
    PdpRespSimilarItemsContainerComponent,
    {
        item: graphql`
            fragment PdpRespSimilarItemsContainer_item on Item {
                isSold
            }
        `,
    }
);
